<div #textContent [matTooltip]="innerText" matTooltipClass="popover-simple-text" [matTooltipDisabled]="truncateDisabled || !textOverflow">
    <ng-content></ng-content>
</div>
